export default "__VITE_ASSET__BaV_7kgp__"